import axios from "axios";
import { TVerifyLineUserResponse } from "../types/line";

/**
 * Verify access token and get UserMale info
 * Used when app opens from talkmail redirect with token
 */
const verifyByToken = async (
  token: string,
  userLineId: number,
): Promise<TVerifyLineUserResponse> => {
  try {
    const response = await axios.post<TVerifyLineUserResponse>(
      "line/verify-token",
      { token, userLineId },
    );
    return response.data;
  } catch (error: unknown) {
    console.error("❌ [API] verify-token failed", {
      status: axios.isAxiosError(error) ? error.response?.status : undefined,
    });
    throw error;
  }
};

export { verifyByToken };
